module.exports = __webpack_public_path__ + "img/forgotPass.123f776e.svg";